<template>

    <div class="container-center">

        <el-form class="invite-form" label-width="140px" ref="form" :model="form" :rules="rules">

            <el-row>

                <el-col :span="7">
                    <el-form-item label="中标公告名称：" prop="name">
                        <el-input size="medium" v-model="form.name" clearable></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="13">
                    <el-form-item label="发布日期：" prop="date">
                        <!--value-format="yyyy-MM-dd hh:mm:ss"-->
                        <el-date-picker
                            v-model="dateRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>

            <!--</el-row>-->


            <!--<el-row>-->

                <el-col :span="3" :offset="1">
                    <el-button type="warning" class="btn-theme" size="medium" @click="queryList" icon="el-icon-search">搜索</el-button>
                </el-col>

            </el-row>

        </el-form>


        <div class="invite-list-box">

            <div class="no-data-tip" v-if="inviteList.length == 0"></div>

            <div v-else class="invite-list" v-for="list in inviteList">
                <div class="invite-list-calen">
                    <span class="big">{{ list.fdistributedate | date('date') }}</span>
                    <span>{{ list.fdistributedate | date('month') }}月</span>
                    <span>{{ list.fdistributedate | date('year') }}</span>
                </div>
                <div class="invite-list-info">
                    <p :class="[list.finvitemethod.charAt(0) === '3' ? 'strategy' : '', 'title']">
                        <router-link :to="'/WinDetail/'+ encodeURIComponent(list.inviteProjectId)">
                            {{list.projectName}}
                        </router-link>
                    </p>
                    <p><span class="icon-type">中标单位：</span><span>{{ list.supplierName }}</span></p>
                    <!-- list.supplierStockList | stockName  -->
                </div>
            </div>

        </div><!-- .invite-list-box -->

        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                :current-page="pager.pageNum"
                :total="pager.total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
                >
            </el-pagination>
        </div>
        <!--
            @size-change="handleSizeChange"
            :current-page.sync="currentPage1"
        -->

    </div><!-- container-center -->

</template>

<script type="text/babel">
import filter from '@/filter'
import banner from '@/assets/imgs/banner_inviteMng.png'

export default {
    name: 'win-bid-list',
    data () {
        return {
            rules: {
                date: [{validator: this.checkDate, message:'开始时间不能晚于结束时间', trigger: 'blur' }]
            },
            inviteList: [],
            dateRange: ['',''],
            form: {
                name: "",
                productTypeName: "",
                signBeginTime: "",
                signEndTime: "",
                signStatus: "1",
            },
            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            }

        }
    },
    filters: filter,
    methods: {
        doQuery () {
            const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
            this.$http.post('/rest/api/project/inquiry/winInfo', {
                pageNum: this.pager.pageNum,
                pageSize: this.pager.pageSize,
                supplierId: this.$root.stockId,
                projectName: this.form.name,
                signBeginTime: this.dateRange && this.dateRange[0] ? filter.date(this.dateRange[0]) +' 00:00:00': '',
                signEndTime: this.dateRange && this.dateRange[0] ? filter.date(this.dateRange[1]) +' 23:59:59': ''
            }).then(res=>{
                loading.close();
                if(res.data.result) {
                    this.inviteList = res.data.value.list;
                    this.pager.total = res.data.value.count;
                    this.pager.pageNum = res.data.value.pageNo;
                }
            })
        },
        queryList () {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.doQuery()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleCurrentChange (page) {
            this.pager.pageNum = page;
            this.queryList();
        },
        checkDate(rule, value, callback){
            if(this.dateRange){
                let begin = this.dateRange[0],
                    end = this.dateRange[1];
                if(end >= begin){
                    this.form.signBeginTime = filter.date(begin) +' 00:00:00';
                    this.form.signEndTime = filter.date(end) +' 23:59:59';
                    callback()
                }else{
                    callback(new Error(rule.message))
                }
            }else{
                callback()
            }

        }
    },
    created(){
        this.$root.navs = [{name:'中标公告',path:'/winList'}]
        this.$root.headImage.src = banner
        this.$root.activeIndex = 'win'
    },
    mounted () {
        this.doQuery();
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';


.invite-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}

.invite-list {width: 100%;height: 96px;padding: 24px 0;border-bottom: 1px solid #E4E5E4;}


/* 日历日期 */
.invite-list-calen {float: left;width: 92px;height: 92px;border: 1px solid #DDDEDD;}
.invite-list-calen > span {display: block;font-size: 14px;padding: 1px 10px;}
.invite-list-calen > span.big {color: var(--cMain);line-height: 32px;font-size: 32px;padding-top: 10px;padding-bottom: 4px;}

.invite-list-info {float: left;margin-left: 40px;}

.invite-list-info > p {margin: 0 0 16px 0;colors: #000;font-size: 14px;}
.invite-list-info > p.title {font-size: 18px;font-weight: bold;}
.invite-list-info > p.title a {color: #000;text-decoration: none;}
.invite-list-info > p.title a:hover {color: var(--cMain);}
.invite-list-info > p.title.strategy::after {content: '战略';display: inline-block;width: 40px;height: 22px;line-height: 22px;text-align: center;font-size: 12px;font-weight: normal;color: #fff;background: var(--cMint);border-radius: 2px;vertical-align: bottom;margin-left: 10px;}
.invite-list-info > p > span[class^=icon] {display: inline-block;color: #646464;padding-left: 22px;height: 15px;line-height: 16px;background: url("../../../assets/imgs/icon_invite_list_tri.png") no-repeat top left;}
.invite-list-info > p > span.icon-time {background-position: 0 -15px;}
.invite-list-info > p > span.icon-proj {background-position: 0 -30px;}
.invite-list-info > p > span + span[class^=icon] {margin-left: 30px;}


</style>



// WEBPACK FOOTER //
// src/pages/dsp/win/List.vue